import React from 'react'
import { Edit, SimpleForm, TextInput } from 'react-admin'

const PgyLevelUpdate = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="label" />
      <TextInput source="value" />
    </SimpleForm>
  </Edit>
)

export default PgyLevelUpdate
